import React from 'react'
import { DraftTabs } from './DraftTabs'
import { Callout } from './Callout'
import { DraftNews } from './DraftNews'
import { DRAFT_YEAR } from '../../Config/League/league.config'
import { PrevDraftCon } from './PrevDrafts/PrevDraftCon'
import { AdUnit } from '../../Components/Ads/AdUnit'
import { Head2 } from '../../Components/Typography/Text.styles'
import { DraftTrades } from './DraftTrades'
import { DraftProvider } from '../../Context/DraftContext/DraftContext'

const Draft: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <DraftProvider>
      <Callout />
      <AdUnit bannerType="bannerMain" aria-label="Draft page ad header" />
      <Head2 vertMargins={2} sideMargins={2}>
        {DRAFT_YEAR} Draft Order
      </Head2>
      <DraftTabs year={DRAFT_YEAR} />
      <DraftTrades />
      <DraftNews />
      <AdUnit bannerType="bannerSecond" aria-label="Draft page ad footer" />
      <PrevDraftCon />
    </DraftProvider>
  )
}
export default Draft
